import styled from "styled-components";

export const ScheduledPlaylistCardStyle = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: row;
  align-items: stretch;
  min-height: 120px;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
    border-color: rgba(255, 255, 255, 0.2);
    background: rgba(255, 255, 255, 0.08);
  }
  
  .card-image-wrapper {
    position: relative;
    width: 120px;
    min-width: 120px;
    overflow: hidden;
    flex-shrink: 0;
  }
  
  .card-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .card-content {
    padding: 14px 16px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 0;
  }
  
  .playlist-name {
    font-size: 15px;
    font-weight: 600;
    color: #ffffff;
    margin: 0 0 12px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 1.3;
  }
  
  .schedule-info {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  
  .info-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
  }
  
  .info-label {
    font-size: 11px;
    color: #888;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    flex-shrink: 0;
  }
  
  .info-value {
    font-size: 12px;
    color: #e0e0e0;
    text-align: right;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    
    /* Inline pill-style badge for type (visible in the info row) */
    .type-badge-inline {
      display: inline-block;
      padding: 3px 10px;
      border-radius: 999px;
      font-size: 11px;
      font-weight: 700;
      color: #fff;
      min-width: 60px;
      text-align: center;
      box-shadow: 0 2px 8px rgba(0,0,0,0.2);
      border: 1px solid rgba(255,255,255,0.06);
    }

    /* Variants */
    .type-badge-inline.refresh {
      border: 1px solid rgba(59,130,246,0.95);
      background: rgba(59,130,246,0.15);
    }

    .type-badge-inline.reset {
      border: 1px solid rgba(168,85,247,0.95);
      background: rgba(168,85,247,0.15);
    }
  }
  
  /* Tablet and smaller */
  @media (max-width: 768px) {
    min-height: 100px;
    
    .card-image-wrapper {
      width: 100px;
      min-width: 100px;
    }
    
    .card-content {
      padding: 12px;
    }
    
    .playlist-name {
      font-size: 14px;
      margin-bottom: 10px;
      -webkit-line-clamp: 1;
    }
    
    .info-label {
      font-size: 10px;
    }
    
    .info-value {
      font-size: 11px;
      
      .type-badge-inline {
        font-size: 10px;
        padding: 2px 8px;
        min-width: 50px;
      }
    }
  }
  
  /* Mobile */
  @media (max-width: 480px) {
    .card-image-wrapper {
      width: 80px;
      min-width: 80px;
    }
    
    .info-row {
      gap: 8px;
    }
  }
`;

